module.exports = __webpack_public_path__ + "img/elementwidths_jasa.0276f272.png";